import type { ReactNode } from 'react';
import { verificationPolicyLabel } from '@/modules/agreements/shared';
import { StepUpVerification } from './step-up-verification';
import type { InteractiveSigningMethod } from '@/modules/agreements/subject/pages/signing-page/hooks/use-signing';
import type { SigningSessionResponse } from '@/api/schemas/agreements.types';

/**
 * The fresh identity check stage.
 *
 * A `fresh_strong` requirement cannot be satisfied by re-attesting the session. The signer
 * must prove possession of a passkey or security key NOW, immediately before signing.
 */
export function VerificationSection(props: {
  executionId: string;
  ensureSession: (method: InteractiveSigningMethod) => Promise<SigningSessionResponse>;
  signingMethod: InteractiveSigningMethod;
  onVerified: (verificationId: string) => void;
}): ReactNode {
  return (
    <div className="space-y-3">
      <p className="text-sm text-content-muted">
        {verificationPolicyLabel('fresh_strong')} — a passkey or security key proves it is you,
        now.
      </p>
      <StepUpVerification
        executionId={props.executionId}
        ensureSession={props.ensureSession}
        signingMethod={props.signingMethod}
        onVerified={props.onVerified}
      />
    </div>
  );
}
